<template>
    <div class="banner_section custom-banner-section">
        <div v-bind:class="{banner_loading : banner_loading}">
            <slick ref="slick" :options="slickOptions"  class="banner-slider stick-dots" v-if="banners!=null">
                <div class="slide" v-for="banner in banners" v-bind:key="banner.id">
                    <div class="slide__img">
                        <NwImg :src="hostname+'/admin/images/banner_images/'+banner.banner" alt="Home slider" />
                    </div>
                </div> 
            </slick>
        </div>
    </div>
</template>
<script>
import Slick from 'vue-slick';
import axios from 'axios'
import 'slick-carousel/slick/slick.css';


export default {
    name: 'HomeSlider',
    components: { Slick },

    data() {
        this.init_banner();
        return {
            slickOptions: {
                dots: false,
                infinite: true,
                speed: 300,
                autoplay: true,
                autoplaySpeed: 5000,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                pauseOnHover:false,
                // Any other options that can be got from plugin documentation
            },
            banners:null,
            hostname:this.$hostname,
            locale:this.$i18n_global.locale,
            banner_loading:true
        }
    },
    methods: {
        async init_banner() {
            var _self = this; 
            await axios.post(this.$hostname+'/api/banner-images',{
                slug:"home"
            })
            .then((res) => {
                var response = res.data.banners;
                _self.banners = response;
                _self.banner_loading = false;
            })
            .catch((error) => {
                console.log(error);
                return false;  
            }) 
            return false; 
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Home/HomeSlider.vue